export const GRAPHQL_FIELD_GRAPH_STORE = 'graphStore';
export const GRAPHQL_FIELD_AGS_RELATIONSHIP_PROJECTS = 'projectHasRelatedWorkWithProject';

export const GRAPHQL_TYPE_JIRA_PROJECT = 'JiraProject';
export const GRAPHQL_TYPE_JIRA_AVATAR = 'JiraAvatar';
